import { render, staticRenderFns } from "./ArticleFrame.vue?vue&type=template&id=a1f50d62&scoped=true&"
import script from "./ArticleFrame.vue?vue&type=script&lang=js&"
export * from "./ArticleFrame.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFrame.vue?vue&type=style&index=0&id=a1f50d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f50d62",
  null
  
)

export default component.exports